import { render, staticRenderFns } from "./WizardNew.vue?vue&type=template&id=14a14492"
import script from "./WizardNew.vue?vue&type=script&lang=js"
export * from "./WizardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports